import ResidentPortal from '@/views/resident-portal/ResidentPortal.vue'

const meta = { residentUserOnly: true }

const metaWithResident = {
  requiresAuth: true,
  residentUserOnly: true
}

export default {
  path: 'portal',
  name: 'resident-portal',
  component: ResidentPortal,
  children: [
    {
      path: 'resident-general',
      name: 'resident-general',
      meta: { ...metaWithResident, permissions: [] },
      component: () => import('@/views/resident-portal/ResidentPage.vue')
    },
    {
      name: 'resident-portal-payment',
      path: 'payment/:residentId',
      component: () => import('@/views/app/payment/Payment.vue'),
      meta: {
        requiresAuth: true
      },
      redirect: { name: 'resident-portal-payment-one-time' },
      children: [
        {
          name: 'resident-portal-payment-one-time',
          path: 'one-time-payment',
          component: () => import('@/views/app/payment/one-time/OneTime.vue'),
          meta: { ...meta, permissions: [] }
        },
        {
          name: 'resident-portal-payment-one-time-success',
          path: 'one-time-payment/success/:paymentId',
          component: () => import('@/views/app/payment/one-time/OneTimeSuccess.vue'),
          meta: { ...meta, permissions: [] }
        },
        {
          name: 'resident-portal-payment-one-time-failure',
          path: 'one-time-payment/failure/:paymentId',
          component: () => import('@/views/app/payment/one-time/OneTimeFailure.vue'),
          meta: { ...meta, permissions: [] }
        }
        // {
        //     name: 'resident-portal-payment-schedule',
        //     path: 'schedule',
        //     component: () => import('@/views/app/payment/schedule/Schedule.vue'),
        //     meta: { ...meta, permissions: [] }
        // },
        // {
        //     name: 'resident-portal-payment-autopay',
        //     path: 'autopay',
        //     component: () => import('@/views/app/payment/autopay/Autopay.vue'),
        //     meta: { ...meta, permissions: [] }
        // },
        // {
        //     name: 'resident-portal-payment-schedule-success',
        //     path: 'schedule/success/:scheduleId',
        //     component: () => import('@/views/app/payment/schedule/ScheduleSuccess.vue'),
        //     meta: { ...meta, permissions: [] }
        // },
        // {
        //     name: 'resident-portal-payment-autopay-success',
        //     path: 'autopay/success/:scheduleId',
        //     component: () => import('@/views/app/payment/autopay/AutopaySuccess.vue'),
        //     meta: { ...meta, permissions: [] }
        // }
        // {
        //     name: 'resident-portal-payment-schedule-success',
        //     path: 'schedule/success/:scheduleId',
        //     component: () => import('../app/payment/schedule/ScheduleSuccess.vue'),
        //     meta: { ...meta, permissions: [] }
        // },
        // {
        //     name: 'resident-portal-payment-autopay-success',
        //     path: 'autopay/success/:scheduleId',
        //     component: () => import('../app/payment/autopay/AutopaySuccess.vue'),
        //     meta: { ...meta, permissions: [] }
        // }
      ]
    }
  ]
}
